module.exports = __webpack_public_path__ + "static/img/5areaA_6.dfae7eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/5areaA_6.png
// module id = 825
// module chunks = 1